import { request } from '../utils/request'
import { urlStringify } from '../utils/index'
import Vue from 'vue'
const Api = {
  // 内容发布 列表
  getmessages: option => {
    return request('v1/vendormessage/getmessages', option, true)
  },
  // 获取内容
  getmessage: option => {
    const urls = urlStringify(option)
    return request('v1/vendormessage/getmessage' + urls, {}, true, false)
  },
  // 内容发布 删除
  deletemessage: option => {
    const urls = urlStringify(option)
    return request('v1/vendormessage/deletemessage' + urls, {}, true)
  },
  // 新增内容发布
  addmessage: option => {
    return request('v1/vendormessage/addmessage', option, true, false)
  },
  // 修改内容发布
  updatemessage: option => {
    return request('v1/vendormessage/updatemessage', option, true, false)
  },
  // 获取首页信息
  getportalhomepage: option => {
    const urls = urlStringify(option)
    return request('v1/wxappportal/getportalhomepage' + urls, {}, true)
  },
  // 修改主页模版
  updateportalpage: option =>
    request('v1/wxappportal/updateportalpage', option, true),
  // 获取积分商城商品列表
  getgoodslist: option =>
    request('v1/points/exchangegoods/getgoodslist', option, true),
  // 获取已发布内容
  getpubablemessages: option => {
    return request('v1/vendormessage/getpubablemessages', option, true)
  },

  goodstopflag: option => request('v1/goods/topflag' + urlStringify(option), {}, true),
  experttopflag: option => request('v1/expert/topflag' + urlStringify(option), {}, true),
  vendortopflag: option => request('v1/vendor/topflag' + urlStringify(option), {}, true),
  servorgtopflag: option => request('v1/servorg/topflag' + urlStringify(option), {}, true),
  servtopflag: option => request('v1/serv/topflag' + urlStringify(option), {}, true)
}

Vue.prototype.$$PortalApi = Api
export default Api
